require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-institution-asian-development-bank.json") })
        }
      }, "path---en-us-institution-asian-development-bank");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-institution-asian-development-bank!./.cache/json/en-us-institution-asian-development-bank.json
// module id = 480
// module chunks = 231608221292675